import React from "react";
import PropTypes from "prop-types";
import { Colors } from "../../constants/Colors";
import styled from "styled-components";
import PENDO_LINK_ID from "../../constants/pendoConstants";

const CustomRevealLink = styled.a`
  text-decoration: underline;
  text-decoration-color: ${Colors.black};
  color: inherit;
  cursor: pointer;
  text-underline-offset: 3px;
`;

const RevealLink = ({ onClick }) => {
  return (
    <CustomRevealLink
      id={PENDO_LINK_ID.REVEAL_LINK}
      href="#"
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      Reveal
    </CustomRevealLink>
  );
};

RevealLink.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default RevealLink;